import { render, staticRenderFns } from "./ResolutionsCatalog.vue?vue&type=template&id=e989e61c&"
import script from "./ResolutionsCatalog.vue?vue&type=script&lang=js&"
export * from "./ResolutionsCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports